var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createDemoPeriodComparisonMatcher } from '@web/lib/demo/utils';
import { formatDuration, getInterval, getPercentageDiff, getPreviousPeriod, groupByPeriod } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var mockCurrentPeriodData = [
    { planned: 3, adhoc: 2, plannedDuration: 5400, adhocDuration: 3600 },
    { planned: 2, adhoc: 4, plannedDuration: 3600, adhocDuration: 7200 },
    { planned: 4, adhoc: 1, plannedDuration: 7200, adhocDuration: 1800 },
    { planned: 1, adhoc: 3, plannedDuration: 1800, adhocDuration: 5400 },
    { planned: 3, adhoc: 2, plannedDuration: 5400, adhocDuration: 3600 },
    { planned: 2, adhoc: 5, plannedDuration: 3600, adhocDuration: 9000 },
    { planned: 5, adhoc: 1, plannedDuration: 9000, adhocDuration: 1800 }
];
var mockPrevPeriodData = [
    { planned: 2, adhoc: 3, plannedDuration: 3600, adhocDuration: 5400 },
    { planned: 3, adhoc: 2, plannedDuration: 5400, adhocDuration: 3600 },
    { planned: 1, adhoc: 4, plannedDuration: 1800, adhocDuration: 7200 },
    { planned: 4, adhoc: 1, plannedDuration: 7200, adhocDuration: 1800 },
    { planned: 2, adhoc: 3, plannedDuration: 3600, adhocDuration: 5400 },
    { planned: 3, adhoc: 2, plannedDuration: 5400, adhocDuration: 3600 },
    { planned: 1, adhoc: 4, plannedDuration: 1800, adhocDuration: 7200 }
];
var TEAM_PERIOD_TOTALS = [
    { planned: 24, adhoc: 16 },
    { planned: 20, adhoc: 20 },
    { planned: 28, adhoc: 12 },
    { planned: 22, adhoc: 18 },
    { planned: 18, adhoc: 22 },
    { planned: 26, adhoc: 14 },
    { planned: 20, adhoc: 20 }
];
var TEAM_USER_COUNT = 8;
export var plannedVSAdHocMeetings = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var dateFrom = startOfDay(input.dateFrom);
    var dateTo = endOfDay(input.dateTo);
    var _a = getPreviousPeriod(input.dateFrom, input.dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
    var periods = groupByPeriod([], dateFrom, dateTo, interval);
    var previousPeriods = groupByPeriod([], startOfDay(prevPeriodDateFrom), endOfDay(prevPeriodDateTo), interval);
    var periodMatcher = createDemoPeriodComparisonMatcher(input, interval, periods, previousPeriods);
    var periodsData = periods.map(function (period, idx) {
        var _a;
        var currentData = mockCurrentPeriodData[idx % mockCurrentPeriodData.length];
        var prevPeriod = periodMatcher.getItem(idx, previousPeriods);
        var previousIndex = prevPeriod
            ? previousPeriods.indexOf(prevPeriod)
            : null;
        var prevData = mockPrevPeriodData[(previousIndex !== null && previousIndex !== void 0 ? previousIndex : idx) % mockPrevPeriodData.length];
        return __assign({ period: period.date, previousPeriodLabel: (_a = prevPeriod === null || prevPeriod === void 0 ? void 0 : prevPeriod.date) !== null && _a !== void 0 ? _a : '', planned: currentData.planned, adhoc: currentData.adhoc, plannedDuration: currentData.plannedDuration, adhocDuration: currentData.adhocDuration, prevPlanned: prevData.planned, prevAdhoc: prevData.adhoc, prevPlannedDuration: prevData.plannedDuration, prevAdhocDuration: prevData.adhocDuration }, (input.userId && {
            teamPlanned: Math.round(TEAM_PERIOD_TOTALS[idx % TEAM_PERIOD_TOTALS.length].planned /
                TEAM_USER_COUNT),
            teamAdhoc: Math.round(TEAM_PERIOD_TOTALS[idx % TEAM_PERIOD_TOTALS.length].adhoc /
                TEAM_USER_COUNT)
        }));
    });
    var currentTotals = mockCurrentPeriodData.reduce(function (acc, data) { return ({
        planned: acc.planned + data.planned,
        adhoc: acc.adhoc + data.adhoc,
        plannedDuration: acc.plannedDuration + data.plannedDuration,
        adhocDuration: acc.adhocDuration + data.adhocDuration
    }); }, { planned: 0, adhoc: 0, plannedDuration: 0, adhocDuration: 0 });
    var prevTotals = mockPrevPeriodData.reduce(function (acc, data) { return ({
        planned: acc.planned + data.planned,
        adhoc: acc.adhoc + data.adhoc
    }); }, { planned: 0, adhoc: 0 });
    var teamPlannedTotal = TEAM_PERIOD_TOTALS.reduce(function (sum, period) { return sum + period.planned; }, 0);
    var teamAdhocTotal = TEAM_PERIOD_TOTALS.reduce(function (sum, period) { return sum + period.adhoc; }, 0);
    return {
        periods: periodsData,
        totals: {
            planned: __assign({ current: currentTotals.planned, currentDuration: formatDuration(currentTotals.plannedDuration), previous: getPercentageDiff(prevTotals.planned, currentTotals.planned) }, (input.userId && {
                teamAverage: getPercentageDiff(Math.round(teamPlannedTotal / TEAM_USER_COUNT), currentTotals.planned)
            })),
            adhoc: __assign({ current: currentTotals.adhoc, currentDuration: formatDuration(currentTotals.adhocDuration), previous: getPercentageDiff(prevTotals.adhoc, currentTotals.adhoc) }, (input.userId && {
                teamAverage: getPercentageDiff(Math.round(teamAdhocTotal / TEAM_USER_COUNT), currentTotals.adhoc)
            }))
        }
    };
};
